import { IconsMap } from '@nx-frontend/shared/ui/icon';
import { AllDocsBtnProps } from '@nx-frontend/shared/types';

export const allDocsButtons: AllDocsBtnProps[] = [
  {
    icon: IconsMap.DOCUMENT,
    title: 'New Page',
    titleLocKey: 'webnotes.webnotes-new_page',
    subTitle: 'Start writing on a blank page',
    subTitleLocKey: 'webnotes.webnotes-new_page_description',
    id: 'newPage',
  },
  // {
  //   icon: IconsMap.DOWNLOAD,
  //   title: 'Import',
  //   subTitle: 'Import from other platforms',
  //   id: 'import',
  // },
  {
    icon: IconsMap.TASKS_PLUS,
    title: 'New Task',
    titleLocKey: 'webnotes.webnotes-new_task',
    subTitle: 'Manage your workflow with tasks',
    subTitleLocKey: 'webnotes.webnotes-new_task_description',
    id: 'newTask',
  },
  {
    icon: IconsMap.TEMPLATE,
    title: 'Templates',
    titleLocKey: 'webnotes.webnotes-templates',
    subTitle: 'Browse & pick a template',
    subTitleLocKey: 'webnotes.webnotes-templates_description',
    id: 'template',
  },
];
